// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'workspaces'

/**
 * Workspace Model Interface (auto-generated from Drizzle schema)
 */
export interface WorkspaceModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description: string
  tags?: string[]
  status: string
  archivedAt?: string
  archived: boolean
  icon?: string
  color?: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "tags": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "archivedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "archived": {
          "type": "boolean"
      },
      "icon": {
          "type": "string",
          "maxLength": 50
      },
      "color": {
          "type": "string",
          "maxLength": 20
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "description",
      "status",
      "archived"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "name",
          "createdAt"
      ],
      [
          "status",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
